module.exports = __webpack_public_path__ + "img/P150T_weapon_111.b38e25d5.png";